export const isIpac = window.location.hostname === 'www.ipac-online.com';

export const sourceOriginLead = isIpac ? 'ipaconline' : 'ecolefrancaise';

export const urlFormAlternance: string =
  'https://lecolefrancaise.fr/formulaire-alternance-generique/';

export const urlFormBtoB: string =
  'https://lecolefrancaise.fr/formulaire-entreprise-generique/';

export const urlFormBtoCtoB: string =
  'https://lecolefrancaise.fr/formulaire-apprenant-entreprise/';
